import { render } from "./Localidad.vue?vue&type=template&id=2c6496db"
import script from "./Localidad.vue?vue&type=script&lang=js"
export * from "./Localidad.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__